var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 16.12 16.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8617",
    "data-name": "Group 8617",
    transform: "translate(-28.149 -92.879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M106.061,28a8.06,8.06,0,1,0,4.03,1.08,8.06,8.06,0,0,0-4.03-1.08Zm4.986,13.046a7.027,7.027,0,1,1,1.511-2.242,7.026,7.026,0,0,1-1.511,2.242Z",
    transform: "translate(-69.852 64.88)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M211.283,138.268h-2.015a1.008,1.008,0,0,0-1.006,1.008v2.013a1.008,1.008,0,0,0,1.006,1.008h2.015a1.007,1.007,0,0,0,1.007-1.007v-2.017a1.007,1.007,0,0,0-1.007-1.007Zm0,3.023h-2.015v-2.017h2.015Z",
    transform: "translate(-176.586 -41.862)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M368.819,138.268H366.8a1.008,1.008,0,0,0-1.007,1.008v2.013A1.008,1.008,0,0,0,366.8,142.3h2.015a1.006,1.006,0,0,0,1.006-1.007v-2.017a1.006,1.006,0,0,0-1.006-1.007Zm0,3.023H366.8v-2.017h2.015Z",
    transform: "translate(-329.083 -41.862)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M211.283,295.729h-2.015a1.008,1.008,0,0,0-1.006,1.008v2.015a1.008,1.008,0,0,0,1.006,1.008h2.015a1.007,1.007,0,0,0,1.007-1.007v-2.017a1.006,1.006,0,0,0-1.007-1.008Zm0,3.023h-2.015v-2.015h2.015Z",
    transform: "translate(-176.586 -194.287)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M368.819,295.729H366.8a1.008,1.008,0,0,0-1.007,1.008v2.015a1.008,1.008,0,0,0,1.007,1.008h2.015a1.006,1.006,0,0,0,1.006-1.007v-2.017a1.006,1.006,0,0,0-1.006-1.008Zm0,3.023H366.8v-2.015h2.015Z",
    transform: "translate(-329.083 -194.287)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMenu);
export default __webpack_public_path__ + "static/media/dashboard_menu.5415348b9f2f5a405d4b5aab7fe8f6fe.svg";
export { ForwardRef as ReactComponent };